"use client"

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import I18NextHttpBackend from "i18next-http-backend";
import { DateTime } from "luxon";

i18n
    // i18next-http-backend
    .use(I18NextHttpBackend)
    // detect user language
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .init({
        debug: false,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
            format: (value, format, lng) => {
                if (value instanceof Date) {
                    return DateTime.fromJSDate(value)
                        .setLocale(lng)
                        .toLocaleString(DateTime[format]);
                }
                return value;
            },
        },
        // Define supported languages and disable loading for others
        supportedLngs: ["en", "it"],
        nonExplicitSupportedLngs: true,
        load: "languageOnly", // Only load the main language code, e.g., 'en', 'it'

    });


export const supportedLocalesSelect = [
    {
        value: 'en',
        name: 'English',
    },
    {
        value: 'it',
        name: 'Italiano',
    }
];

export default i18n;
